import React, { useEffect, useState } from "react";

import {
  detectDevice,
  getAppStoreUrl,
  trackDownloadWithDevice,
} from "../utils/deviceDetection";

interface AppFooterProps {
  onAppStoreClick?: () => void;
  onPlayStoreClick?: () => void;
}

const AppFooter: React.FC<AppFooterProps> = ({
  onAppStoreClick,
  onPlayStoreClick,
}) => {
  const [deviceInfo, setDeviceInfo] = useState({
    deviceType: "desktop" as "ios" | "android" | "desktop",
    primaryStoreUrl: "https://apps.apple.com/vn/app/locuno/id6753800628",
  });

  useEffect(() => {
    const device = detectDevice();
    const url = getAppStoreUrl(device.deviceType);

    setDeviceInfo({
      deviceType: device.deviceType,
      primaryStoreUrl: url,
    });
  }, []);

  const handlePrimaryStoreClick = () => {
    // Track with device info
    trackDownloadWithDevice(deviceInfo.deviceType);

    // Call appropriate callback
    if (deviceInfo.deviceType === "ios" && onAppStoreClick) {
      onAppStoreClick();
    } else if (deviceInfo.deviceType === "android" && onPlayStoreClick) {
      onPlayStoreClick();
    }
  };

  const handleAppStoreClick = () => {
    trackDownloadWithDevice("ios");
    if (onAppStoreClick) onAppStoreClick();
  };

  const handlePlayStoreClick = () => {
    trackDownloadWithDevice("android");
    if (onPlayStoreClick) onPlayStoreClick();
  };

  return (
    <footer className="text-center py-8">
      <div className="flex items-center justify-center gap-2 mb-4">
        <img src="/logo/icon-full-color.png" alt="Locuno" className="h-8" />
        <div className="text-black">
          <span className="font-bold text-xl">Locuno</span>
          <span className="text-sm text-gray-600 ml-2">Location Uno</span>
        </div>
      </div>
      <p className="text-sm text-gray-600 mb-4">
        Gắn kết cộng đồng địa phương trên khắp Việt Nam.
      </p>
      <div className="flex justify-center gap-4">
        {/* Primary store button (auto-detected) */}
        <a
          href={deviceInfo.primaryStoreUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={handlePrimaryStoreClick}
          className="transition-transform hover:scale-105 ring-2 ring-[#007AFF] ring-opacity-50 rounded-lg"
          title={`Tải cho ${deviceInfo.deviceType === "ios" ? "iOS" : deviceInfo.deviceType === "android" ? "Android" : "thiết bị của bạn"}`}
        >
          <img
            src={
              deviceInfo.deviceType === "android"
                ? "/images/playstore.png"
                : "/images/appstore.png"
            }
            alt={
              deviceInfo.deviceType === "android"
                ? "Get it on Google Play"
                : "Download on App Store"
            }
            className="h-12 w-auto"
          />
        </a>

        {/* Alternative store button */}
        <a
          href={
            deviceInfo.deviceType === "android"
              ? "https://apps.apple.com/vn/app/locuno/id6753800628"
              : "https://play.google.com/store/apps/details?id=com.locunoapp"
          }
          target="_blank"
          rel="noopener noreferrer"
          onClick={
            deviceInfo.deviceType === "android"
              ? handleAppStoreClick
              : handlePlayStoreClick
          }
          className="transition-transform hover:scale-105 opacity-70 hover:opacity-100"
          title={`Tải cho ${deviceInfo.deviceType === "android" ? "iOS" : "Android"}`}
        >
          <img
            src={
              deviceInfo.deviceType === "android"
                ? "/images/appstore.png"
                : "/images/playstore.png"
            }
            alt={
              deviceInfo.deviceType === "android"
                ? "Download on App Store"
                : "Get it on Google Play"
            }
            className="h-12 w-auto"
          />
        </a>
      </div>
    </footer>
  );
};

export default AppFooter;
